import i18next from 'i18next';
export var SumInsured;
(function (SumInsured) {
    SumInsured[SumInsured["A"] = 8000000] = "A";
    SumInsured[SumInsured["B"] = 12000000] = "B";
    SumInsured[SumInsured["C"] = 15000000] = "C";
    SumInsured[SumInsured["D"] = 20000000] = "D";
    SumInsured[SumInsured["E"] = 25000000] = "E";
})(SumInsured || (SumInsured = {}));
(function (SumInsured) {
    function toEuroString(value) {
        return `EUR ${value.toLocaleString(i18next.language)}`;
    }
    SumInsured.toEuroString = toEuroString;
    function createOptions() {
        return [
            { label: toEuroString(SumInsured.A), value: SumInsured.A },
            { label: toEuroString(SumInsured.B), value: SumInsured.B },
            { label: toEuroString(SumInsured.C), value: SumInsured.C },
            { label: toEuroString(SumInsured.D), value: SumInsured.D },
            { label: toEuroString(SumInsured.E), value: SumInsured.E },
        ];
    }
    SumInsured.createOptions = createOptions;
})(SumInsured || (SumInsured = {}));
export var DeductibleSum;
(function (DeductibleSum) {
    DeductibleSum[DeductibleSum["NONE"] = 0] = "NONE";
    DeductibleSum[DeductibleSum["A"] = 290] = "A";
    DeductibleSum[DeductibleSum["B"] = 400] = "B";
    DeductibleSum[DeductibleSum["C"] = 750] = "C";
    DeductibleSum[DeductibleSum["D"] = 1500] = "D";
})(DeductibleSum || (DeductibleSum = {}));
(function (DeductibleSum) {
    function createOptions(t, cascoType) {
        return cascoType === CascoTypeEnum.VOLLKASKO
            ? createVollkaskoOptions(t)
            : createTeilkaskoOptions(t);
    }
    DeductibleSum.createOptions = createOptions;
    function translate(t, sum, cascoType) {
        return cascoType === CascoTypeEnum.VOLLKASKO
            ? createVollkaskoOptions(t).find(({ value }) => sum === value)?.label
            : createTeilkaskoOptions(t).find(({ value }) => sum === value)?.label;
    }
    DeductibleSum.translate = translate;
})(DeductibleSum || (DeductibleSum = {}));
// duplicate in contract (this one is not for external usage)
export var CascoTypeEnum;
(function (CascoTypeEnum) {
    CascoTypeEnum["VOLLKASKO"] = "Vollkasko";
    CascoTypeEnum["TEILKASKOPARKSCHADEN"] = "Teilkasko mit Parkschaden";
    CascoTypeEnum["TEILKASKO"] = "Teilkasko ohne Parkschaden";
})(CascoTypeEnum || (CascoTypeEnum = {}));
export var CascoType;
(function (CascoType) {
    function createOptions(t) {
        return [
            {
                label: t('wheelie:form.insuranceSegments.comprehensive.casco.Teilkasko'),
                value: CascoTypeEnum.TEILKASKO,
            },
            {
                label: t('wheelie:form.insuranceSegments.comprehensive.casco.Vollkasko'),
                value: CascoTypeEnum.VOLLKASKO,
            },
        ];
    }
    CascoType.createOptions = createOptions;
    function translate(t, value) {
        return t(`wheelie:form.insuranceSegments.comprehensive.casco.${value}`);
    }
    CascoType.translate = translate;
    function getValues() {
        return [CascoTypeEnum.VOLLKASKO, CascoTypeEnum.TEILKASKO];
    }
    CascoType.getValues = getValues;
})(CascoType || (CascoType = {}));
const createVollkaskoOptions = (t) => [
    {
        label: t('wheelie:form.enum.deductibleSum.A'),
        value: DeductibleSum.A,
    },
    {
        label: t('wheelie:form.enum.deductibleSum.B'),
        value: DeductibleSum.B,
    },
    {
        label: t('wheelie:form.enum.deductibleSum.C'),
        value: DeductibleSum.C,
    },
    {
        label: t('wheelie:form.enum.deductibleSum.D'),
        value: DeductibleSum.D,
    },
];
const createTeilkaskoOptions = (t) => [
    {
        label: t('wheelie:form.enum.deductibleSum.NONE'),
        value: DeductibleSum.NONE,
    },
    {
        label: t('wheelie:form.enum.deductibleSum.A'),
        value: DeductibleSum.A,
    },
];
